import React, { createContext, useRef, useState } from "react";

export const EwaContext = createContext({});

export const EwaProvider = ({ children }) => {
  const [ewaDocs, setEwaDocs] = useState([]);
  const [isViewerVisible, setIsViewerVisible] = useState(false);
  const [ewaOpenDocumentInfo, setEwaOpenDocumentInfo] = useState(null);
  const [ewaPaths, setEwaPaths] = useState(() => new Set());
  const [ewaOpenDocumentActive, setEwaOpenDocumentActive] = useState(false);
  const [screenNameReady, setScreenNameReady] = useState(true);
  const [isBuilderInitialised, setIsBuilderInitialised] = useState(false);

  const lastDocIdRef = useRef(null);
  const navigatedDocsRef = useRef(new Set());

  const markDocAsNavigated = (id) => {
    navigatedDocsRef.current.add(id);
  };

  return (
    <EwaContext.Provider
      value={{
        ewaDocs, setEwaDocs,
        isViewerVisible, setIsViewerVisible,
        ewaOpenDocumentInfo, setEwaOpenDocumentInfo,
        ewaOpenDocumentActive, setEwaOpenDocumentActive,
        ewaPaths, setEwaPaths,
        screenNameReady, setScreenNameReady,
        lastDocIdRef,
        navigatedDocsRef,
        markDocAsNavigated,
        isBuilderInitialised, setIsBuilderInitialised,
      }}
    >
      {children}
    </EwaContext.Provider>
  );
};